// activityNewUser2
export default {
  routerTitle: '新客户三重奖赏',
  giftPackage: '礼包',
  shareTitle: '新客户三重奖赏，可享受高达3800港元大礼包！ ',
  shareDesc: '马上入CASH的话再送你1500港元现金礼包！ ',

  cardOneTitle: '注册就送88HKD礼包',
  cardOneText: '30天美股LV1行情券',

  cardTwoTitle: '开户就送2256HKD礼包',
  cardTwoText1: '180天港股LV2',
  cardTwoText2: '180天美股LV1',

  cardThreeTitle: '入金2W最高赠送',
  cardThreeTabelTitle: '首笔入金≥2万HKD',
  cardThreeTabelRow1Left1: '无要求',
  cardThreeTabelRow1Right1: '入金就送',
  cardThreeTabelRow1Right2: '300HKD',
  cardThreeTabelRow1Right3: '现金券',
  cardThreeTabelRow2Left1: '60天内无出金记录',
  cardThreeTabelRow2Left2: '且60天内交易一次',
  cardThreeTabelRow2Right1: '满足条件就送',
  cardThreeTabelRow2Right2: '500HKD',
  cardThreeTabelRow2Right3: '现金券',

  cardFourTitle: '入金20W最高赠送',
  cardFourTabelTitle: '首笔入金≥20万HKD',
  cardFourTabelRow1Left1: '60天内无出金记录',
  cardFourTabelRow1Left2: '且60天内交易一次',
  cardFourTabelRow1Right1: '满足条件就送',
  cardFourTabelRow1Right2: '1500HKD',
  cardFourTabelRow1Right3: '现金券',

  pageTips: '注：首笔入金2W和首笔入金20W奖励只能参与一个',
  receiveErr1: '交易1次且留存60天可再得500HKD哦！',
  receiveErr2: '不符合参加活动的条件',

  cardThreeTabelRow1Left1Cn: '30天内无出金记录',
  cardThreeTabelRow1Left2Cn: '且30天内交易一次',
  cardThreeTabelRow1Right1Cn: '满足条件就送',
  cardThreeTabelRow1Right2Cn: '500HKD',
  cardThreeTabelRow1Right3Cn: '现金券',
  cardFourTitleCn: '入金30W最高赠送',
  cardFourTabelTitleCn: '首笔入金≥30万HKD',
  cardFourTabelRow1Left1Cn: '30天内无出金记录',
  cardFourTabelRow1Left2Cn: '且30天内交易一次',
  cardFourTabelRow1Right1Cn: '满足条件就送',
  cardFourTabelRow1Right2Cn: '1500HKD',
  cardFourTabelRow1Right3Cn: '现金券',
  pageTipsCn: '注：首笔入金2万奖励和首笔入金30万奖励只能参与一个'
}
